import type { FunctionComponent, PropsWithChildren } from 'react'
import React, { createContext, useContext } from 'react'

import { invariant } from '@app/utils/invariant'

import type { RouteContextInterface } from './types'

const Context = createContext<RouteContextInterface | null>(null)

export const RouteContextProvider: FunctionComponent<PropsWithChildren<{ val: RouteContextInterface }>> = ({ val, children }) => {
  return <Context value={val}>{children}</Context>
}

export const useRoute = <T extends Record<any, any> = Record<string, string>>() => {
  const val = useContext(Context)
  if (!val) return invariant('RouteContext not provided')
  return val as RouteContextInterface<T>
}
